//const baseUrl: string = "http://52.183.134.182:8080/";
const baseUrl: string = "https://pp-app-xp.mozark.ai:8443/";
// const baseUrl: string = "https://aquamark.mozark.ai:8443/";
const subbaseUrl:string = "https://pp-app-xp.mozark.ai:8888/";
// export const redirectUrl: string = "https://aquamark-dev.mozark.ai:8443/";
// export const passwordRedirectUrl: string = "http://localhost:4200/reset-password";
export const passwordRedirectUrl: string = window&& window['location'] &&window['location']['origin']
?window['location']['origin']:"http://localhost:4200/reset-password";

export const configs = {
    cardType: {
        addCard: "addCard",
        viewMore: "viewMore",
        addGraph: "addGraph",
        AQI: "AQI",
        errorPopup: "errorPopup",
        EditWidget: "EditWidget",
        view: "view",
        viewAlert: "viewAlert",
        editAlert: "editAlert",
        selectOrder: "selectOrder",
        AddNewAlert: "AddNewAlert",
        change: "change",
        notification: "notification",
        showAll: "showAll",
        createUser: "createUser",
        editProfile: "editProfile",
        changePassword: "changePassword",
        defineThresholds: "defineThresholds",
        defineweights: "defineweights",
        manageUsers: "manageUsers",
        appScore: "appScore",
        aqiPercentage: "aqiPercentage",
        scoreRange: "scoreRange",
        scorePercentage: "scorePercentage",
        changeConditions: "changeConditions",
        updateComparison: "updateComparison",
        addComparisonMobility: "addComparisonMobility",
        changeConditionsMobility: "changeConditionsMobility",
        mobilityCompare: "mobilityCompare",
        classifyEsni: "classifyEsni",
        editUser: "editUser",
        downloadCSV:"downloadCSV",
    },
    api: {
        signInUser: baseUrl + "UxDashBoard/user/signin",
        fetchOrderList: baseUrl + "UxDashBoard/order/list",
        fetchGetFormula: baseUrl + "UxDashBoard/formula/getformula/",
        fetchkeyKPIOFDeviceDetail: baseUrl + "UxDashBoard/performance/keykpisdevice/",
        fetchDataCollection: baseUrl + "performance/dashboard/datacollection",
        fetchESNITypeList: baseUrl + "UxDashBoard/performance/esnitypelist/",
        downloadCSV: baseUrl + "UxDashBoard/download/csv/",
        fetchESNIType: baseUrl + "UxDashBoard/performance/getesnitype/",
        fetchESNIListAppWise: baseUrl + "UxDashBoard/performance/getesnilist/",
        setESNIType: baseUrl + "UxDashBoard/performance/setesnitype/",
        fetchAlertList: baseUrl + "UxDashBoard/alert/get/",
        markAsViewed: baseUrl + "UxDashBoard/alert/viewed/",
        fetchComparisionChart: baseUrl + "UxDashBoard/diagnostic/comparison/",
        addThreshold: baseUrl + "UxDashBoard/formula/addthresholds/",
        addWeight: baseUrl + "UxDashBoard/formula/addweights/",
        fetchKeyKPIList: baseUrl + "UxDashBoard/diagnostic/keykpilists/",
        fetchConditionList: baseUrl + "UxDashBoard/order/scoreconditions/",
        fetchTrendLine: baseUrl + "UxDashBoard/diagnostic/getTrend/",
        deleteAlert: baseUrl + "UxDashBoard/alert/delete/",
        fetchKPIsOfTestId: baseUrl + "UxDashBoard/order/getkpis/",
        resetPassword: baseUrl + "UxDashBoard/customer/resetpassword",
        fetchUserList: baseUrl + "UxDashBoard/admin/listusers",
        enableUser: baseUrl + "UxDashBoard/admin/manageuser",
        manageAdmin: baseUrl + "UxDashBoard/admin/manageadmin",
        updateProfile: baseUrl + "UxDashBoard/customer/profile/",
        fetchUserDetail: baseUrl + "UxDashBoard/customer/profile/",
        changePassword: baseUrl + "UxDashBoard/customer/updatepassword/",
        forgetPassword: baseUrl + "UxDashBoard/customer/forgotpassword",
        fetchTestId: baseUrl + "performance/job/testids/",
        fetchKpiList: baseUrl + "UxDashBoard/order/kpilists/",
        fetchMonitorGraph: baseUrl + "UxDashBoard/monitorgraph/getmonitorgraphs/",
        MonitorGraph: baseUrl + "UxDashBoard/monitorgraph/",
        updateCardPosition: baseUrl + "UxDashBoard/monitor/updateposition/",
        fetchCard: baseUrl + "UxDashBoard/monitor/getcard/",
        updateGraphTab: baseUrl + "UxDashBoard/monitorgraph/updatepagetab/",
        updateBenchmarkGraphTab: baseUrl + "UxDashBoard/benchmark/updatepagetab/",
        fetchSpeed: baseUrl + "UxDashBoard/order/networktag/",
        fetchLocation: baseUrl + "UxDashBoard/order/cities/",
        fetchNetworks: baseUrl + "UxDashBoard/order/networks/",
        fetchDevicecategory: baseUrl + "UxDashBoard/order/devicecategory/",
        updateESNIType: baseUrl + "UxDashBoard/performance/updateesnitype/",
        fetchTimeWindow: baseUrl + "UxDashBoard/order/timewindow/",
        fetchPlatform: baseUrl + "UxDashBoard/order/platform/",
        fetchAppversion: baseUrl + "UxDashBoard/order/appversion/",
        fetchApp: baseUrl + "UxDashBoard/order/app/",
        addCard: baseUrl + "UxDashBoard/monitor/addcard/",
        fetchAggregation: baseUrl + "UxDashBoard/order/aggregation/",
        fetchXvalue: baseUrl + "UxDashBoard/order/xlists/",
        addGraphMonitor: baseUrl + "UxDashBoard/monitorgraph/",
        addGraphBenchmark: baseUrl + "UxDashBoard/benchmark/",
        updatecard: baseUrl + "UxDashBoard/monitor/updatecard/",
        deletecard: baseUrl + "UxDashBoard/monitor/deletecard/",
        fetchBenchMarkGraph: baseUrl + "UxDashBoard/benchmark/getbenchmarkgraphs/",
        GraphBenchmark: baseUrl + "UxDashBoard/benchmark/",
        timeserieskpislist: baseUrl + "UxDashBoard/performance/timeserieskpislist/",
        addNewAlertApi: baseUrl + "UxDashBoard/alert/add/",
        issues: baseUrl + "UxDashBoard/performance/issues/",
        uxTrend: baseUrl + "UxDashBoard/monitorgraph/timeseriestrend/",
        fetchSettingsData: baseUrl + "UxDashBoard/formula/readformula/",
        // fetchWaterfall: baseUrl + "UxDashBoard/performance/waterfall/",
        //http://localhost:8080/UxDashBoard/performance/waterfallnewui/025b13284095ffbd1599707137667
        fetchWaterfall: baseUrl + "UxDashBoard/performance/waterfallnewui/",
        fetchPerformanceTimeseries: baseUrl + "UxDashBoard/performance/timeseries/",
        fetchPerformanceEsni: baseUrl + "UxDashBoard/performance/esni/",
        fetchPerformanceKpiEsni: baseUrl + "UxDashBoard/performance/keykpisesni/",
        fetchPerformanceKpisPcap: baseUrl + "UxDashBoard/performance/keykpispcap/",
        fetchPerformanceError: baseUrl + "UxDashBoard/performance/keykpispcap/error/",
        fetchPerformanceEsniError: baseUrl + "UxDashBoard/performance/keykpisesni/error/",
        fetchPerformanceProtocolList: baseUrl + "UxDashBoard/performance/protocollist/",
        fetchPerformanceTracker: baseUrl + "performance/dashboard/tracker/",
        createNewUser: baseUrl + "UxDashBoard/customer/signup",
        downloadPcap:baseUrl+"UxDashBoard/download/pcap/",
        monitoringpageTab:baseUrl+"UxDashBoard/monitorgraph/updatepagetabname/",
        benchmarkingpageTab:baseUrl+"UxDashBoard/benchmark/updatepagetabname/",
        keykpisesnitype:baseUrl+"UxDashBoard/performance/keykpisesnitype/",
        deleteEsniType:baseUrl+"UxDashBoard/performance/deleteesnitype/",
        selectedPcap:baseUrl+"performance/job/v2/testids",
        updateAlert:baseUrl+"UxDashBoard/alert/update/",
        downloadPcapType:subbaseUrl+"download/csv/",
        externalAnalysis:subbaseUrl+'download/external/',
        drillDownESNI : baseUrl + "UxDashBoard/diagnostic/drilldownesni/",
        orderKpiList : baseUrl + "UxDashBoard/performance/orderkpislist/",
        getInspectESNI : baseUrl + "UxDashBoard/diagnostic/inspectesni/"
    }
}